import React, { useContext, useEffect, useState } from 'react'
import styles from "../../Styles/ComponentStyles/MainPages/Leadership.module.scss"
import globalStyles from "../../Styles/global.module.scss"

import Grid from '@mui/material/Grid2';
import { Checkbox, FormControlLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import AppNavbar from '../../Components/AppNavbar/AppNavbar'
import GlobalButton from '../../Utils/Layout/GlobalButton/GlobalButton';
import DashboardNavbar from '../Dashboard/DashboardNavbar/DashboardNavbar';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { leadershipData } from '../../Utils/Constant/Constant';
import GlobalDialog from '../../Utils/Layout/GlobalDialog/GlobalDialog';
import GlobalWarningDialog from '../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog';
import { AppAccessResponseInterface, AppApproveRejectInterface } from '../../models/dashboardAxiosModels';
import { GlobalUserContext, GlobalUserContextPayload } from '../../Context/GlobalUserDetailContext';
import agent from '../../Services/api';
import { useSnackbar } from '../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';


const Leaderboard = () => {

    const {
        setFlagLoader,
        userProfileDetails
    } = useContext(GlobalUserContext) as GlobalUserContextPayload
    const { showSnackbar } = useSnackbar();


    const [appAccessResponseDetails, setAppAccessResponseDetails] = useState<AppAccessResponseInterface[] | null>(null)
    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate()
    const [flagOpenApproveRejectDialog, setFlagOpenApproveRejectDialog] = useState<boolean>(false)
    const [flagApproveReject, setFlagApproveReject] = useState<string>()
    const [appApproveRejectData, setAppApproveRejectData] = useState<AppApproveRejectInterface>({
        app_name: "",
        app_id: null,
        user_id: null,
        status: null
    })

    useEffect(() => {
        setFlagLoader(true)
        getAppAccessDetails()
    }, [])

    useEffect(() => {
        if (userProfileDetails.flagLoggedIn && appAccessResponseDetails) {
            const user_id = parseInt(searchParams.get('user_id') || '', 10);
            const app_id = parseInt(searchParams.get('app_id') || '', 10);
            const status = searchParams.get('status');
            const app_name = userProfileDetails.apps?.find((app) => app_id === app.appId)?.appName

            const appExist = appAccessResponseDetails?.find((app) => app_id === app.app_id && user_id === app.user_id)
            if (appExist) {
                setFlagOpenApproveRejectDialog(true);
                if (status) {
                    setFlagApproveReject(status);
                    setAppApproveRejectData({
                        app_name: app_name,
                        app_id: app_id,
                        user_id: user_id,
                        status: status
                    });
                }
            } else {
                setSearchParams({})
            }
        }
    }, [appAccessResponseDetails])

    const getAppAccessDetails = async () => {
        const adminAccessId = 1
        try {
            const response = await agent.getAppAccessDataApi.get(adminAccessId);
            if (response.status) {
                setAppAccessResponseDetails(response?.data)
                setFlagLoader(false)
            }
            else {
                // console.log("Error in response", response);
                showSnackbar("Something Went Wrong", 'error')
                setFlagLoader(false)
            }
        } catch (error) {
            console.error("Error fetching app access data", error);
            showSnackbar("Something Went Wrong", 'error')
            setFlagLoader(false)
        }
    }

    const handleApproveRejectClick = (status: string, data: AppAccessResponseInterface) => {
        setFlagOpenApproveRejectDialog(true);
        setFlagApproveReject(status);
        setAppApproveRejectData({
            app_name: data.app_name,
            app_id: data.app_id,
            user_id: data.user_id,
            status: status
        });
    };
    const handleApproveRejectRequest = async () => {
        setFlagLoader(true)
        setFlagOpenApproveRejectDialog(false)
        try {
            const payload: AppApproveRejectInterface = {
                app_id: appApproveRejectData?.app_id,
                user_id: appApproveRejectData?.user_id,
                status: appApproveRejectData?.status
            }
            const response = await agent.appApproveRejectApi.post(payload)
            if (response?.status) {
                showSnackbar(response?.message, 'success')
                getAppAccessDetails()
            } else {
                const error = response?.error?.message ? response?.error?.message : "Something Went Wrong!"
                showSnackbar(error, 'error')
            }
            setFlagLoader(false)
        } catch (error) {
            setFlagLoader(false)
            console.error("Error during approve reject request", error);
            showSnackbar("Something Went Wrong!", 'error')
        }
    }

    const handleClick = () => {
        navigate('/')
    }

    return (
        <>
            {flagOpenApproveRejectDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    open={flagOpenApproveRejectDialog}
                    maxWidth="sm"
                    dialogHead={flagApproveReject === 'Approved' ? 'Approve Confirmation' : 'Reject Confirmation'}
                    view={
                        <GlobalWarningDialog
                            popupDescription={`Are you sure you want to ${flagApproveReject === 'Approved' ? 'approve' : 'reject'} ${appApproveRejectData?.app_name}?`}
                            primaryButtonText={flagApproveReject === 'Approved' ? 'Approve' : 'Reject'}
                            secondaryButtonText={"Close"}
                            primaryButtonWidth="175px"
                            secondaryButtonWidth="175px"
                            onDelete={handleApproveRejectRequest}
                            handleClose={() => { setFlagOpenApproveRejectDialog(false) }}
                        />
                    }
                    onClose={() => { setFlagOpenApproveRejectDialog(false) }}
                />
            }

            <DashboardNavbar
                onClick={handleClick}
                headName="App Access Request"
            />
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <TableContainer className={`${globalStyles.gblTableContainerStyles}`} >
                        <Table size='small' className={`${globalStyles.gblTableStyles}`}>
                            <TableHead className={`${globalStyles.gblTableHeadStyles}`}>
                                <TableRow>
                                    <TableCell
                                        className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableMediumWidth}`}
                                        sx={{ fontSize: "14px", borderTopLeftRadius: "5px" }}
                                    >
                                        USER NAME
                                    </TableCell>
                                    <TableCell
                                        className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableLargeWidth}`}
                                        sx={{ fontSize: "14px" }}
                                    >
                                        REQUESTED APP NAME
                                    </TableCell>
                                    <TableCell
                                        className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableSmallWidth}`}
                                        sx={{ fontSize: "14px" }}
                                    >
                                        REQUESTED TIME
                                    </TableCell>
                                    <TableCell
                                        className={`${globalStyles.gblTableHeadCell} ${globalStyles.gblTableLargeWidth}`}
                                        sx={{ fontSize: "14px", borderTopRightRadius: "5px" }}
                                    >
                                        ADMIN
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {appAccessResponseDetails?.map((row: AppAccessResponseInterface, index: number) => (
                                    <TableRow
                                        key={index}
                                        className={`${globalStyles.gblTableBodyRow}`}
                                    >
                                        <TableCell
                                            className={`${globalStyles.gblTableCellText}`}
                                        >
                                            {row.username}
                                        </TableCell>

                                        <TableCell
                                            className={`${globalStyles.gblTableCellText}`}
                                        >
                                            {row.app_name}
                                        </TableCell>

                                        <TableCell
                                            className={`${globalStyles.gblTableCellText}`}
                                        >
                                            {row.timestamp.split("T")[0]}
                                        </TableCell>

                                        <TableCell
                                            className={`${globalStyles.gblTableCellText}`}
                                        >
                                            <Grid container sx={{ columnGap: "15px" }}>
                                                <Grid>
                                                    <GlobalButton
                                                        value="Approve"
                                                        size='small'
                                                        variant='contained'
                                                        className={`${styles.approveBtn}`}
                                                        onClick={() => handleApproveRejectClick('Approved', row)}
                                                    />
                                                </Grid>
                                                <Grid>
                                                    <GlobalButton
                                                        value="Reject"
                                                        size='small'
                                                        variant='contained'
                                                        className={`${styles.rejectBtn}`}
                                                        onClick={() => handleApproveRejectClick('Rejected', row)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </>
    )
}

export default Leaderboard